const initialState = {
    PROFILE_DATA: {},
};

export default function Reducer(state = initialState, action) {

    switch (action.type) {
        case "UPDATE_PROFILE_DATA":
            return {
                ...state,
                // PROFILE_DATA: action.payload,
                PROFILE_DATA: {
                    ...action.payload,
                    modules: [
                        ...(action.payload.modules || []),
                        { module_id: 20, name: "Fund Scheme", short_name: "Fund Scheme" },
                        // { module_id: 5, name: "SIP", short_name: "SIP" },
                        // { module_id: 13, name: "Manage banners", short_name: "Manage banners" }
                    ]
                }
            };
        default:
            return state;
    }
}
